import { Button } from "@progress/kendo-react-buttons";
import ConfirmationModal from "commons/modal/ConfirmationModal";
import AddAmbianceAssignesModal from "pages/gant/components/modals/AddAmbianceAssignesModal";
import AddProduitsAssignesModal from "pages/gant/components/modals/AddProduitsAssignesModal";
import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useAddCampagneTypeProdMutation, useRemoveCampagneReqMutation, useUpdateCampagneReqMutation } from "../../../redux/api/cache";

export default function PlanificationButtonsCells(props) {
    const [confirmationDeleteModalVisible, setConfirmationDeleteModalVisible] =
        useState(false);
    const [removeCampagneReq] = useRemoveCampagneReqMutation();
    const [updateCampagneReq] = useUpdateCampagneReqMutation();
    const [addCampagneTypeProd] = useAddCampagneTypeProdMutation();
    const [modalAjoutProduitVisible, setModalAjoutProduitVisible] = useState(false);
    const [modalAjoutAmbianceVisible, setModalAjoutAmbianceVisible] = useState(false);

    const addProd = async (values) => {
        await addCampagneTypeProd(values);
    };

    return <>
        <td style={{ width: '100%', display: 'flex', columnGap: '15px' }}>
            <Button className="blueButton" onClick={() => setModalAjoutProduitVisible(true)}>Ajouter un produit</Button>
            <Button className="blueButton" onClick={() => setModalAjoutAmbianceVisible(true)}>Ajouter une ambiance</Button>
            {props.dataItem.inEdit === true ? <>
                <span className="blueButton k-icon k-font-icon k-i-save" style={{ cursor: "pointer" }} onClick={() => { updateCampagneReq(props.dataItem); props.setRowEdit(props.dataItem, false); }} title="Enregistrer" />
                <span className="blueButton k-icon k-font-icon k-i-cancel" style={{ cursor: "pointer" }} onClick={async () => { props.setRowEdit(props.dataItem, false); }} title="Annuler" />
            </>
                :
                <><span className="blueButton k-icon k-font-icon k-i-edit" style={{ cursor: "pointer" }} onClick={() => { props.setRowEdit(props.dataItem, true); }} title="Mettre à jour le requis" />
                    <span className="blueButton k-icon k-font-icon k-i-trash" style={{ cursor: "pointer" }} onClick={async () => { setConfirmationDeleteModalVisible(!confirmationDeleteModalVisible); }} title="Supprimer le requis" />
                </>
            }
            {confirmationDeleteModalVisible && (
                <ConfirmationModal
                    text={`Voulez-vous supprimer cette ligne de planification?`}
                    onClose={() => {
                        setConfirmationDeleteModalVisible(false);
                    }}
                    onConfirm={async () => {
                        setConfirmationDeleteModalVisible(false);
                        await removeCampagneReq(props.dataItem.rid);
                    }}
                />
            )}
            {modalAjoutProduitVisible && (
                <AddProduitsAssignesModal
                    toggleDialog={() => setModalAjoutProduitVisible(false)}
                    infos={props.dataItem}
                    create={addProd}
                    annonce={props.annonce}
                />
            )}
            {modalAjoutAmbianceVisible && (
                <AddAmbianceAssignesModal
                    toggleDialog={() => setModalAjoutAmbianceVisible(false)}
                    infos={props.dataItem}
                    create={addProd}
                    annonce={props.annonce}
                />
            )}
        </td>

    </>;
}

PlanificationButtonsCells.propTypes = {
    dataItem: PropTypes.any,
    annonce: PropTypes.any,
    setRowEdit: PropTypes.any
};